export const mrpa_V1_0_0_StaticFilesIds = [
  'mrpa-v1_0_0-general-terms',
  'mrpa-v1_0_0-ipid',
  'mrpa-v1_0_0-assistance-special-terms',
  'mrpa-v1_0_0-hospitality-special-terms',
  'mrpa-v1_0_0-manufacturing-special-terms',
  'mrpa-v1_0_0-dab-pf-general-terms',
  'mrpa-v1_0_0-rce-general-terms',
] as const

export const mrpa_V1_0_1_StaticFilesIds = [
  'mrpa-v1_0_1-general-terms',
  'mrpa-v1_0_0-ipid',
  'mrpa-v1_0_0-assistance-special-terms',
  'mrpa-v1_0_0-hospitality-special-terms',
  'mrpa-v1_0_0-manufacturing-special-terms',
  'mrpa-v1_0_0-dab-pf-general-terms',
  'mrpa-v1_0_0-rce-general-terms',
] as const

export const mrpa_V1_0_2_StaticFilesIds = [
  'mrpa-v1_0_1-general-terms',
  'mrpa-v1_0_0-ipid',
  'mrpa-v1_0_0-hospitality-special-terms',
  'mrpa-v1_0_0-manufacturing-special-terms',
  'mrpa-v1_0_0-dab-pf-general-terms',
  'mrpa-v1_0_0-rce-general-terms',
  'mrpa-v1_0_2-assistance-special-terms',
] as const

export const mrpa_V1_0_3_StaticFilesIds = [
  'mrpa-v1_0_3-general-terms',
  'mrpa-v1_0_0-ipid',
  'mrpa-v1_0_3-hospitality-special-terms',
  'mrpa-v1_0_3-manufacturing-special-terms',
  'mrpa-v1_0_3-dab-pf-general-terms',
  'mrpa-v1_0_3-rce-general-terms',
  'mrpa-v1_0_3-assistance-special-terms',
] as const

export const mrpa_V1_0_4_StaticFilesIds = [
  'mrpa-v1_0_3-general-terms',
  'mrpa-v1_0_4-ipid',
  'mrpa-v1_0_3-hospitality-special-terms',
  'mrpa-v1_0_3-manufacturing-special-terms',
  'mrpa-v1_0_3-dab-pf-general-terms',
  'mrpa-v1_0_3-rce-general-terms',
  'mrpa-v1_0_4-assistance-special-terms',
] as const

export const mrpa_V1_1_0_StaticFilesIds = [
  'mrpa-v1_0_3-general-terms',
  'mrpa-v1_0_4-ipid',
  'mrpa-v1_0_3-hospitality-special-terms',
  'mrpa-v1_0_3-manufacturing-special-terms',
  'mrpa-v1_0_3-dab-pf-general-terms',
  'mrpa-v1_0_3-rce-general-terms',
  'mrpa-v1_0_4-assistance-special-terms',
] as const

export const mrpa_V1_2_0_StaticFilesIds = [
  'mrpa-v1_0_3-general-terms',
  'mrpa-v1_0_4-ipid',
  'mrpa-v1_0_3-hospitality-special-terms',
  'mrpa-v1_0_3-manufacturing-special-terms',
  'mrpa-v1_0_3-dab-pf-general-terms',
  'mrpa-v1_0_3-rce-general-terms',
  'mrpa-v1_0_4-assistance-special-terms',
] as const

export const mrpa_V1_3_0_StaticFilesIds = [
  'mrpa-v1_0_3-general-terms',
  'mrpa-v1_0_4-ipid',
  'mrpa-v1_0_3-hospitality-special-terms',
  'mrpa-v1_0_3-manufacturing-special-terms',
  'mrpa-v1_0_3-dab-pf-general-terms',
  'mrpa-v1_0_3-rce-general-terms',
  'mrpa-v1_0_4-assistance-special-terms',
] as const
